import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { loadFonts } from "./utils/loadFonts";
loadFonts();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-225" data-mp="21cag26t4o9gu" />);
}